import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClipboard } from "@fortawesome/free-regular-svg-icons";
import "./style.css";

export default function Box({ text, author, copyToClipboard }) {

  return (
    <div className="box">
      <p className="text">{text}</p>
      <p className="author">{author}</p>
      <button onClick={() => copyToClipboard(text)} className="btn_copie">
        <FontAwesomeIcon icon={faClipboard} />
      </button>
    </div>
  );
}
